/* @ngInject */
export default function (
  $stateProvider
) {
  $stateProvider.state('app.marketing', {
    url: 'marketing?url',
    template: '<div ng-non-bindable id="page-marketing" class="col-sm-24 max-height"></div>'
  });
}
